import React from 'react';
import './AIAgentInstructions.css';
import { FaRobot, FaTimes } from 'react-icons/fa';

const AIAgentInstructions = ({ call, onClose, onSend }) => {
  if (!call) {
    return null;
  }

  const suggestions = [
    'Address the 2 urgent loads that are running behind schedule. Request updated ETAs and notify shippers of any delays.',
    'Handle the critical shipment issue - Load #45892 needs immediate attention for delivery documentation.',
    'Resolve payment discrepancies for invoices #3421 and #3455 before processing new loads.'
  ];

  return (
    <div className="ai-instructions-modal-overlay">
      <div className="ai-instructions-modal">
        <div className="ai-instructions-header">
          <h3><FaRobot /> AI Agent Instructions</h3>
          <button onClick={onClose} className="close-btn"><FaTimes /></button>
        </div>
        <div className="ai-instructions-body">
          <p>Provide instructions for the AI agent to handle this call with {call.name}.</p>
          <h4>Smart Suggestions (based on caller history):</h4>
          <div className="suggestions-list">
            {suggestions.map((suggestion, index) => (
              <button key={index} className="suggestion-item">
                {suggestion}
              </button>
            ))}
          </div>
          <h4>Or write your own custom instructions:</h4>
          <textarea placeholder="Enter instructions for the AI agent..."></textarea>
        </div>
        <div className="ai-instructions-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-send" onClick={onSend}><FaRobot /> Send to AI Agent</button>
        </div>
      </div>
    </div>
  );
};

export default AIAgentInstructions;